module.exports = __webpack_public_path__ + "img/leval-9.815206b2.png";